import { render, staticRenderFns } from "./LawProductCategoryList.vue?vue&type=template&id=c465bbb4&"
import script from "./LawProductCategoryList.vue?vue&type=script&lang=js&"
export * from "./LawProductCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./LawProductCategoryList.vue?vue&type=style&index=0&id=c465bbb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports